import apiClient from './api-client';
import { API_URL } from '../services/SarafanApiClient';

// User
const getUserDetail = ({ id }) =>
  apiClient.get(`/users/details/${id}`, {});

const getUsersList = ({ namePrefix }) =>
  apiClient.get(`/users/list/${encodeURIComponent(namePrefix)}`, {});

const postUsersEdit = ( userData ) =>
  apiClient.post(`/users/edit`, userData);

const getUsersGallery = ({ id }) =>
    apiClient.get(`/gallery/${id}`, {});

const postGalleryCreate = ( data ) =>
    apiClient.post(`/photos/upload`, data);

const postUserGalleryUpdate = ( data ) =>
    apiClient.post(`/gallery`, data);

const postAuth = ( data ) =>
  apiClient.post(`/auth/login`, data);

// Skills
const getSkillsList = () =>
  apiClient.get(`/skills/list`, {});

// Cities
const getCitiesList = () =>
  apiClient.get(`/cities/list`, {});

// Analytics
const getAnalyticsList = () =>
  apiClient.get(`/analytics/list`, {});

const getTopProLinks = () =>
  apiClient.get(`/analytics/funnels/top-prolinks`, {});

const getProFunnel = () =>
  apiClient.get(`/analytics/funnels/pro`, {});

const getClientFunnel = () =>
  apiClient.get(`/analytics/funnels/client`, {});

const getStatistic = () =>
  apiClient.get(`/analytics/funnels/statistic`, {});

// Orders
const getOrdersList = () =>
  apiClient.get(`/orders/list`, {});

// cancelOrder
const postСancelOrder = ({ id }) =>
  apiClient.post(`/orders/cancel`, {id});

// verifyOrder
const postVerifyOrder = ({ id }) =>
  apiClient.post(`/orders/verify`, {id});

// Analytics
const postAnalyticsEdit = ({ user }) =>
  apiClient.post(`/analytics/edit`, user);

export default {
  getUserDetail,
  getUsersList,
  getUsersGallery,
  postUsersEdit,
  postAuth,
  getSkillsList,
  getOrdersList,
  postAnalyticsEdit,
  postСancelOrder,
  postGalleryCreate,
  postUserGalleryUpdate,
  postVerifyOrder,
  getAnalyticsList,
  getTopProLinks,
  getProFunnel,
  getClientFunnel,
  getStatistic,
  getCitiesList,
};



// WEBPACK FOOTER //
// ./src/lib/Api.js